module.exports = __webpack_public_path__ + "img/list_D30A.0c2121d3.png";